import type { ApiErrorBody, ApiErrorType } from './types';

/**
 * Wirft `client.ts` für jede nicht-2xx-Antwort der rest-api-Unit (ausser den
 * Authentifizierungsfällen 401/403/503, die über den `AuthErrorHandler`
 * separat behandelt werden, siehe business-logic-model-web-oberflaeche
 * Abschnitt "Fehlerbehandlung" und security-design-web-oberflaeche).
 */
export class ApiError extends Error {
  readonly status: number;
  readonly type: ApiErrorType | 'NetworkError';
  readonly fieldErrors: Readonly<Record<string, string>> | undefined;

  constructor(status: number, body: ApiErrorBody | null, fallbackMessage: string) {
    super(body?.error.message ?? fallbackMessage);
    this.status = status;
    this.type = body?.error.type ?? 'NetworkError';
    this.fieldErrors = body?.error.fieldErrors;
  }
}

/**
 * performance-design-web-oberflaeche: TanStack Query retried ausschliesslich
 * Netzwerkfehler oder HTTP 5xx -- niemals eine fachliche Fehlerantwort
 * (ValidationError/NotFoundError/MalformedRequestError) oder 401/403
 * (die laufen ohnehin ueber die eigene Authentifizierungs-Fehlerbehandlung).
 */
export function isNetworkOrServerError(error: unknown): boolean {
  if (!(error instanceof ApiError)) {
    return true; // z.B. TypeError bei fetch-Netzwerkfehler
  }
  return error.type === 'NetworkError' || error.status >= 500;
}
